import api from '../../../utils/api'
import { useState, useEffect } from "react"
import generatePDF, { Margin, Resolution } from 'react-to-pdf'

/* img */
import logo from '../../../shared/img/logo.png'

/* Credit cards img */
import Visa from "../../../shared/img/creditCard/visa.png"
import Amex from "../../../shared/img/creditCard/amex.png"
import Mastercard from "../../../shared/img/creditCard/mastercard.png"
import Hipercard from "../../../shared/img/creditCard/hipercard.png"
import Elo from "../../../shared/img/creditCard/elo.png"
import Dinersclub from "../../../shared/img/creditCard/dinersclub.png"

/* functions */
import TimestampToString from '../../../shared/functions/TimestampToString'
import NumberToMoney from '../../../shared/functions/NumberToMoney'

import './ProposalPDF.css'

const configPDF = {
    method: 'build',
    // .pdf-body já é renderizado em 2480px (~300dpi de A4) — resolution MEDIUM (padrão, 3x)
    // triplicava isso pra ~900dpi à toa, gerando PDFs de vários MB. LOW (1x) já é nítido o suficiente.
    resolution: Resolution.LOW,
    page: {
        margin: Margin.MEDIUM,
        format: 'A4',
        orientation: 'portrait',
    }
}

const contentToPDF = () => document.getElementById('content-id')

// Renderiza a proposta em tamanho de impressão e, assim que os dados carregam, gera o PDF
// e devolve o bloburl via onReady — quem chama decide se mostra isso na tela ou some com o processo.
function ProposalPDFContent({ id, onReady }) {
    const [budgetInfo, setBudgetInfo] = useState({})
    const [budgetItem, setBudgetItem] = useState([])
    const [client, setClient] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')
    const [pdfTriggered, setPdfTriggered] = useState(false)
    const { timeStampToDateString } = TimestampToString()

    useEffect(() => {
        api.get(`order/budget/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        })
            .then((response) => {
                setBudgetInfo(response.data.budget)
                setClient(response.data.budget.client)
                setBudgetItem(response.data.budget.orderItemArray)
            })
    }, [token, id])

    useEffect(() => {
        if (budgetInfo.code && !pdfTriggered) {
            setPdfTriggered(true)
            setTimeout(async () => {
                const pdf = await generatePDF(contentToPDF, configPDF)
                if (pdf) {
                    onReady(pdf.output('bloburl'))
                }
            }, 300)
        }
    }, [budgetInfo, pdfTriggered])

    const descriptionText = (product) => {
        let text = ""

        if (product.category) {
            text = text + " " + product.category.label
        }
        if (product.cloth) {
            text = text + " " + product.cloth.label
        }
        if (product.sex) {
            text = text + " " + product.sex.label
        }
        if (product.colors.length) {
            product.colors.map((i) => {
                text = text + ", " + i.label
            })
        }
        if (product.additive.length) {
            product.additive.map((i) => {
                if (i.checked) {

                    text = text + ", com " + i.name
                } else {
                    text = text + ", sem " + i.name
                }

            })
        }
        if (product.accessoriesSelected.length) {
            product.accessoriesSelected.map((i) => {
                text = text + ", com " + i.name


            })
        }
        return text
    }


    const groupSize = (data) => {

        // eliminates the number size less than or equal to zero
        let newObj = { ...data, sizes: data.sizes.filter((f) => f.quantity > 0) }


        if (newObj.sizes.length >= 2) {

            let result = [...new Set(newObj.sizes.map(x => x.price))].map(x => {
                return {
                    price: x,
                    name: newObj.sizes.filter(d => d.price == x).map(u => u.name),
                    nameQuant: newObj.sizes.filter(d => d.price == x).map(u => u.quantity + "/" + u.name),
                    quant: newObj.sizes.filter(d => d.price == x).map(u => parseInt(u.quantity)).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    totalPriceCash: NumberToMoney(newObj.sizes.filter(d => d.price == x).map(u => parseFloat(u.totalPriceCash)).reduce((accumulator, currentValue) => currentValue + accumulator, 0)),
                    totalPriceInstalment: NumberToMoney(newObj.sizes.filter(d => d.price == x).map(u => parseFloat(u.totalPriceInstalment)).reduce((accumulator, currentValue) => currentValue + accumulator, 0)),
                    unPriceCash: newObj.sizes.filter(d => d.price == x).map(u => u.unPriceCash).reduce((accumulator, currentValue) => currentValue, 0),
                    unPriceInstalment: newObj.sizes.filter(d => d.price == x).map(u => u.unPriceInstalment).reduce((accumulator, currentValue) => currentValue, 0),

                }

            })
            return (
                result.map((r) =>
                    <>
                        <tr key={r._id} >

                            <td><div className='proposal-table-td1'> {data.code} </div></td>
                            <td><div className='proposal-table-td'> {r.quant} </div></td>
                            <td><div className='proposal-table-td'> {r.nameQuant.map(n => n + "  ")} </div></td>
                            <td><div className='proposal-table-td'> {descriptionText(data)}</div></td>

                            <td><div className='proposal-table-td'>
                                {data.colors.map((c) =>
                                    <>
                                        {c.label}

                                    </>
                                )}
                            </div></td>
                            <td><div className='proposal-table-td'>
                                {data.colors.map((c) =>
                                    <>
                                        {c.ref}

                                    </>
                                )}
                            </div></td>


                            <td><div className='proposal-table-td'> {data.cloth.label}</div></td>
                            <td><div className='proposal-table-td pdf-proposal-no-rap'> R$ {budgetInfo.paymentMethod.value === "inCash" ? r.unPriceCash : r.unPriceInstalment} </div></td>
                            <td><div className='proposal-table-td2 pdf-proposal-no-rap '> R$ {budgetInfo.paymentMethod.value === "inCash" ? r.totalPriceCash : r.totalPriceInstalment} </div></td>

                        </tr>
                        <tr className='pdf-proposal-table-td-sp'>
                            <td colSpan={9} className='  '><div className=''> </div></td>

                        </tr>
                    </>
                )
            )
        }

    }

    return (
        <section className='pdf-body'>
            <div className='pdf-container' id="content-id">




                {/* -------------------------------------- Proposal Head -------------------------------------------------- */}
                <div className='proposal-head'>

                    <img className='pdf-img-logo' src={logo} />
                    <div className='proposal-head-text'>
                        <div>HASTEG CONFECÇÕES LTDA</div>
                        <div>CNPJ: 53.772.712/0001-95</div>
                    </div>


                </div>
                <div className='proposal-pdf-date'>

                    <div><span className='pdf-date-1'>{timeStampToDateString(budgetInfo.updatedAt)}</span> </div>
                    <div><span className=' proposal-pdf-validation-time'> Validade da Proposta: <span className='proposal-pdf-validation-time'>{budgetInfo.proposalTime} </span></span> </div>


                </div>

                {/* -------------------------------------- Client Info -------------------------------------------------- */}
                <div className='pdf-proposal-client-data'>
                    <table>
                        <tr>
                            <td colSpan={2}><div className='pdf-label-text-spacing'><span className='pdf-label-1'>Cliente: </span> <span className='pdf-label-text-1'>{client.name}</span> </div> </td>
                        </tr>
                        {client.personType !== "fisica" && (client.corporateName || client.fantasyName) && (
                            <tr>
                                <td colSpan={2}><div className='pdf-label-text-spacing'><span className='pdf-label-1'>Razão Social: </span> <span className='pdf-label-text-1'>{client.corporateName}{client.fantasyName && ` (${client.fantasyName})`}</span> </div> </td>
                            </tr>
                        )}
                        <tr>
                            {client.personType === "fisica"
                                ? <td><div className='pdf-label-text-spacing'><span className='pdf-label-1'>CPF: </span> <span className='pdf-label-text-1'>{client.CPF}</span> </div></td>
                                : <td><div className='pdf-label-text-spacing'><span className='pdf-label-1'>CNPJ: </span> <span className='pdf-label-text-1'>{client.CNPJ}</span> </div></td>

                            }
                            <td><div className='pdf-label-text-spacing'><span className='pdf-label-1'>A/C: </span> <span className='pdf-label-text-1'>{(client.contacts || []).map((c) => c.name).filter(Boolean).join(', ')}</span> </div></td>

                        </tr>
                        {budgetInfo.clientOrderNumber && (
                            <tr>
                                <td colSpan={2}><div className='pdf-label-text-spacing'><span className='pdf-label-1'>Pedido do Cliente: </span> <span className='pdf-label-text-1'>{budgetInfo.clientOrderNumber}</span> </div> </td>
                            </tr>
                        )}
                        {client.address && (
                            <tr>
                                <td colSpan={2}><div className='pdf-label-text-spacing'><span className='pdf-label-1'>Endereço: </span> <span className='pdf-label-text-1'>{client.address}{client.number && `, ${client.number}`}{client.complement && ` - ${client.complement}`}{client.district && ` - ${client.district}`}</span> </div> </td>
                            </tr>
                        )}
                        <tr>
                            <td><div className='pdf-label-text-spacing'><span className='pdf-label-1'>E-mail: </span> <span className='pdf-label-text-1'>{client.email}</span> </div></td>
                            <td><div className='pdf-label-text-spacing'><span className='pdf-label-1'>Tel.: </span> <span className='pdf-label-text-1'>{(client.contacts || []).map((c) => c.phone).filter(Boolean).join(', ')}</span> </div></td>

                        </tr>
                    </table>

                </div>

                {/* -------------------------------------- Proposal budget itens -------------------------------------------------- */}
                <div>
                    <table className='pdf-proposal-table'>
                        {/* ----------------------------- Proposal budget itens - table head ------------------------- */}
                        <tr >
                            <th><div className='proposal-table-th1'> Cod.</div></th>
                            <th><div className='proposal-table-th'> Quant.</div></th>
                            <th><div className='proposal-table-th'> Tam.</div></th>
                            <th><div className='proposal-table-th'> Descrição</div></th>

                            <th><div className='proposal-table-th'> Cor </div></th>
                            <th><div className='proposal-table-th'> Ref </div></th>
                            <th><div className='proposal-table-th'> Tecido</div></th>
                            <th><div className='proposal-table-th'> Un.</div></th>
                            <th><div className='proposal-table-th2'> Total</div></th>
                        </tr>

                        {/* ----------------------------- Proposal budget itens - table itens ------------------------- */}
                        {budgetItem &&
                            <>
                                <tr className='pdf-proposal-table-th-td-sp'>
                                    <td colSpan={9} ><div className=''> </div></td>

                                </tr>
                                {budgetItem.map((i) =>

                                    <>
                                        {/* ----------------------------- Proposal budget itens - table spacing ------------------------- */}

                                        {!i.simpleProduct ?
                                            groupSize(i)
                                            :
                                            <>
                                                <tr key={i._id} >

                                                    <td><div className='proposal-table-td1'> {i.code} </div></td>
                                                    <td><div className='proposal-table-td'> {i.totalQuantity} </div></td>
                                                    <td><div className='proposal-table-td'> --- </div></td>
                                                    <td><div className='proposal-table-td'> {i.description}</div></td>

                                                    <td><div className='proposal-table-td'>
                                                        ---
                                                    </div></td>
                                                    <td><div className='proposal-table-td'>
                                                        ---
                                                    </div></td>


                                                    <td><div className='proposal-table-td'> --- </div></td>
                                                    <td><div className='proposal-table-td pdf-proposal-no-rap'> R$ {budgetInfo.paymentMethod.value === "inCash" ? i.inCash : i.instalment} </div></td>
                                                    <td><div className='proposal-table-td2 pdf-proposal-no-rap '> R$ {budgetInfo.paymentMethod.value === "inCash" ? i.totalInCash : i.totalInstalment} </div></td>

                                                </tr>
                                                <tr className='pdf-proposal-table-td-sp'>
                                                    <td colSpan={9} className='  '><div className=''> </div></td>

                                                </tr>
                                            </>
                                        }




                                    </>
                                )}
                                {budgetInfo.proposalObs &&
                                    <>
                                        <tr className=''>

                                            <td ><div className='proposal-table-td1'> OBS:</div></td>
                                            <td colSpan={8} ><div className='proposal-table-td-obs'> {budgetInfo.proposalObs} </div></td>


                                        </tr>
                                        <tr className='pdf-proposal-table-th-td-sp'>
                                            <td colSpan={9} ><div className=''> </div></td>

                                        </tr>
                                    </>
                                }
                            </>
                        }



                    </table>
                </div>
                <div className='proposal-pdf-total'>
                    {parseFloat(budgetInfo.additionalDiscount) > 0 &&
                        <>
                            <div className='proposal-pdf-orcamento'>

                                <div className='pdf-label-1'>
                                    Total do Orçamento:
                                </div>
                                <div className='pdf-label-text-1'>R$ {budgetInfo.totalPrice} </div>

                            </div>

                            <div className='proposal-pdf-orcamento'>

                                <div className='pdf-label-1'>
                                    Desconto Adicional:
                                </div>
                                <div className='pdf-label-text-1'>{budgetInfo.additionalDiscount} % </div>

                            </div>

                        </>
                    }
                    <div className='proposal-pdf-orcamento'>

                        <div className='pdf-label-1'>
                            Valor do Orçamento Final:
                        </div>
                        <div className='pdf-label-text-1'>R$ {budgetInfo.orderPrice} </div>

                    </div>
                </div>

                {/* ------------------ info config proposal --------------- */}
                <div className='proposal-pdf-box-info'>

                    <div className='proposal-pdf-box-info-div'>
                        <span className='proposal-pdf-box-info-label'>Previsão de Entrega</span>
                        <div className='proposal-pdf-box-info-text'> <span className='proposal-pdf-delivery' >{budgetInfo.deliveryForecast} </span> </div>
                    </div>
                </div>
                <div className='proposal-pdf-box-info'>

                    <div className='proposal-pdf-box-info-div'>
                        <span className='proposal-pdf-box-info-label'>Condições de Pagamento</span>
                        <div className='proposal-pdf-box-info-text'> <span className='' >{budgetInfo.paymentMethodText} </span> </div>
                        <div className='proposal-pdf-box-credit-card'> {budgetInfo.visa && <img src={Visa} />} {budgetInfo.amex && <img src={Amex} />} {budgetInfo.mastercard && <img src={Mastercard} />} {budgetInfo.hipercard && <img src={Hipercard} />} {budgetInfo.elo && <img src={Elo} />} {budgetInfo.dinersclub && <img src={Dinersclub} />} </div>
                    </div>
                </div>
                <div className='proposal-pdf-box-info'>

                    <div className='proposal-pdf-box-info-div'>
                        <span className='proposal-pdf-box-info-label'>Frete</span>
                        <div className='proposal-pdf-box-info-text'>
                            <div className="proposal-pdf-radio-div">
                                <div className="proposal-pdf-radio-option" >
                                    <div className="proposal-pdf-radio-check-box" >
                                        {budgetInfo.shipping === "cif"
                                            ? <div className='proposal-pdf-radio-check-box-check proposal-pdf-radio-checked'>
                                            </div>
                                            : <div className='proposal-pdf-radio-check-box-check proposal-pdf-radio-uncheked'></div>
                                        }

                                    </div>
                                    <div className='proposal-pdf-radio-option-label'>
                                        CIF
                                    </div>
                                </div>
                                <div className="proposal-pdf-radio-option" >
                                    <div className="proposal-pdf-radio-check-box" >
                                        {budgetInfo.shipping === "fob"
                                            ? <div className='proposal-pdf-radio-check-box-check proposal-pdf-radio-checked'>
                                            </div>
                                            : <div className='proposal-pdf-radio-check-box-check proposal-pdf-radio-uncheked'></div>
                                        }

                                    </div>
                                    <div className='proposal-pdf-radio-option-label'>
                                        FOB (por conta do cliente)
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className='proposal-pdf-box-info'>

                    <div className='proposal-pdf-box-info-div'>
                        <span className='proposal-pdf-box-info-label'>Observações</span>
                        <div className='proposal-pdf-box-info-text'>{budgetInfo.proposalObs}</div>
                    </div>
                </div>
                {/* ------------- signature -------------- */}
                <div className='proposal-pdf-signature'>
                    <strong>Atenciosamente,</strong>
                    <span>{budgetInfo.seller && budgetInfo.seller.name}</span>
                    <span>{budgetInfo.seller && budgetInfo.seller.phone}</span>

                </div>

            </div>
        </section>
    )
}

export default ProposalPDFContent
